/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { AlertQualityGate } from '../models/alert-quality-gate';
@Injectable({
  providedIn: 'root',
})
class AlertQualityGateService extends __BaseService {
  static readonly getAlertsForQualityGatesPath = '/alerts/qualityGates';
  static readonly setAlertToMarkAsReadPath = '/alerts/markAsRead/{index}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return array of alert
   */
  getAlertsForQualityGatesResponse(): __Observable<__StrictHttpResponse<Array<AlertQualityGate>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/alerts/qualityGates`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AlertQualityGate>>;
      })
    );
  }
  /**
   * @return array of alert
   */
  getAlertsForQualityGates(): __Observable<Array<AlertQualityGate>> {
    return this.getAlertsForQualityGatesResponse().pipe(
      __map(_r => _r.body as Array<AlertQualityGate>)
    );
  }

  /**
   * @param index undefined
   * @return was it marked true
   */
  setAlertToMarkAsReadResponse(index: number): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/alerts/markAsRead/${encodeURIComponent(String(index))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param index undefined
   * @return was it marked true
   */
  setAlertToMarkAsRead(index: number): __Observable<boolean> {
    return this.setAlertToMarkAsReadResponse(index).pipe(
      __map(_r => _r.body as boolean)
    );
  }
}

module AlertQualityGateService {
}

export { AlertQualityGateService }
